import ApiClient from 'api-client/ApiClient'

const { resMgr } = ApiClient.getInstance()

interface KeyValuePair {
  key: string
  value: string
}

interface AuditLogProps {
  urlParams: KeyValuePair[]
}

export const downloadAuditLogs = ({ urlParams }: AuditLogProps) => {
  return resMgr.downloadAuditLogs({ urlParams })
}

export const getAuditLogFilters = () => {
  return resMgr.getAuditLogFilters()
}
